import Axios from './setting/semed'

class Semed {
  async get(url) {
    return new Promise(resolve => {
      Axios.get(url).then((response) => {
        resolve(response.data)
      })
    })
  }
}
export default new Semed()
